import { SVGProps } from 'react';
import { Colors } from '@mercator-gcp/grout';
import { ReactComponent } from 'icons/mercator_logo.svg';

import 'components/icons/LogoIcon.scss';

type Props = SVGProps<SVGSVGElement> & { white?: boolean };

/**
 * @deprecated Move to storybook instead
 */
export const LogoIcon = ({ white, ...props }: Props) => {
  return (
    <ReactComponent
      className="merc-icon-logo"
      style={{ color: white ? Colors.White : Colors.ArmyGreen900 }}
      {...props}
    />
  );
};
